import { types } from "../../schemas/generatedTypes";
import { type TObject } from "@sinclair/typebox";

export const dataLayerEventKeys: string[] = Object.values(types.properties).map(
  (schema: TObject) => schema.properties.event.default
);
